import api from 'src/lib/api/client';
import ApiError from 'src/lib/api/error';

const BookingService = {
  async searchBookings({ params }) {
    try {
      const client = await api.getClient();
      return client.searchBookings(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getBooking({ id }) {
    try {
      const client = await api.getClient();
      return client.getBookingReservation(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createBooking({ booking }) {
    try {
      const client = await api.getClient();
      return client.createBooking(null, booking);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateBookingStatus({ id, status }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        // Redirect after update
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateBookingStatus(id, { status });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async searchTimeslots({ params }) {
    try {
      const client = await api.getClient();
      return client.fetchAvailableTimeSlots(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default BookingService;
